import React, { useState, useEffect, useCallback } from 'react';
import { fetchImpactSurveyAnalytics } from '../../api/client';
import ImpactSurveyAnalytics from '../ImpactSurveyAnalytics/ImpactSurveyAnalytics';
import ImpactSurveyList from '../ImpactSurveyList/ImpactSurveyList';

export default function ImpactSurveyTab() {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [surveyTypeFilter, setSurveyTypeFilter] = useState('');

  const loadAnalytics = useCallback(async () => {
    try {
      const params = surveyTypeFilter ? { survey_type: surveyTypeFilter } : undefined;
      const res = await fetchImpactSurveyAnalytics(params);
      setAnalyticsData(res.data);
    } catch (_e) {
      setAnalyticsData(null);
    }
  }, [surveyTypeFilter]);

  useEffect(() => {
    loadAnalytics();
  }, [loadAnalytics]);

  return (
    <div>
      <ImpactSurveyAnalytics analytics={analyticsData} />
      <ImpactSurveyList
        questions={analyticsData?.questions || []}
        surveyTypeFilter={surveyTypeFilter}
        onSurveyTypeChange={setSurveyTypeFilter}
      />
    </div>
  );
}
